export const TAX_SUPPORTED_LOCALES = [
  'en-US',
  'en-CA',
  'fr-CA',
];

export const isTaxSupported = (locale: Maybe<string> = '') => {
  return TAX_SUPPORTED_LOCALES.includes(locale);
};

